import { EditOutlined } from '@ant-design/icons';
import { type RelationEditor } from '@framework/form/form/relations/useRelationEditor.ts';
import { NumberInput } from '@framework/form/inputs/NumberInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { Button, List, Tooltip, Typography } from 'antd';
import { useMemo } from 'react';
import { type IMapLayer } from '../layers/MapLayer.ts';

export interface IMapIdentifyConfigSectionProps {
  layersEditor: RelationEditor<IMapLayer>;
}

/**
 * Sezione nel configuratore widget mappa che mostra l'elenco
 * dei layer con interrogazione (Identify) abilitata.
 */
export function MapIdentifyConfigSection(
  props: IMapIdentifyConfigSectionProps,
) {
  const { layersEditor } = props;

  const identifyLayers = useMemo(
    () => layersEditor.items.filter(layer => layer.identify?.enabled),
    [layersEditor.items],
  );

  return (
    <div>
      <Typography.Paragraph>
        Elenco dei livelli con interrogazione abilitata. Per modificare la
        configurazione, apri la configurazione del livello corrispondente.
      </Typography.Paragraph>

      {identifyLayers.length > 0 && (
        <>
          <FormItem
            label="Buffer selezione puntuale (m)"
            name="identify.bufferDistance"
            help="Raggio di tolleranza per la selezione a punto in Front Office"
          >
            <NumberInput name="identify.bufferDistance" min={1} />
          </FormItem>
          <FormItem
            label="Buffer selezione puntuale BO (m)"
            name="identify.bufferDistanceBO"
            help="Raggio di tolleranza per la selezione a punto in Back Office"
          >
            <NumberInput name="identify.bufferDistanceBO" min={1} />
          </FormItem>
        </>
      )}

      <List
        size="small"
        dataSource={identifyLayers}
        locale={{ emptyText: 'Nessuna interrogazione configurata' }}
        renderItem={layer => {
          const identify = layer.identify!;

          return (
            <List.Item
              actions={[
                <Tooltip title="Modifica" key="edit">
                  <Button
                    size="small"
                    type="text"
                    icon={<EditOutlined aria-label="Modifica interrogazione" />}
                    onClick={e => {
                      e.stopPropagation();
                      layersEditor.handle.open(layer);
                    }}
                  />
                </Tooltip>,
              ]}
            >
              <List.Item.Meta
                title={identify.title || layer.name}
                description={`Layer: ${layer.name} — ${identify.attributes?.length ?? 0} ${identify.attributes?.length === 1 ? 'attributo' : 'attributi'}`}
              />
            </List.Item>
          );
        }}
      />
    </div>
  );
}
